import { render } from "./FormControls.vue?vue&type=template&id=118c7d74"
import script from "./FormControls.vue?vue&type=script&lang=js"
export * from "./FormControls.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__